/**
 * Utilitários para interpretar chave de acesso (44 dígitos) — modelo 55 (NF-e) ou 65 (NFC-e).
 */

export function chaveNfeSomenteDigitos(chave) {
  return String(chave || '').replace(/\D/g, '')
}

/** Modelo do documento nas posições 21–22 da chave (índice 0-based: 20–21). */
export function getModeloFromChave(chave) {
  const digits = chaveNfeSomenteDigitos(chave)
  if (digits.length < 22) return null
  return digits.substring(20, 22)
}

export function isChaveModelo55(chave) {
  return getModeloFromChave(chave) === '55'
}

export function isChaveModelo65(chave) {
  return getModeloFromChave(chave) === '65'
}

/** Chave válida de NFC-e (modelo 65). */
export function isChaveNfce(chave) {
  if (!chave || !String(chave).trim()) return false
  const modelo = getModeloFromChave(chave)
  if (modelo === '65') return true
  if (modelo === '55') return false
  return false
}

/** Chave válida de NF-e modelo 55 gravada em sales.chave_nfe (caso legado). */
export function isChaveNfe55(chave) {
  return isChaveModelo55(chave)
}
